import { render, staticRenderFns } from "./AuctionDetailStats.vue?vue&type=template&id=c6d1be36&scoped=true&"
import script from "./AuctionDetailStats.vue?vue&type=script&lang=ts&"
export * from "./AuctionDetailStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d1be36",
  null
  
)

export default component.exports